import React, { useState, useEffect } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword] = useState(false);
  const [validated, setValidated] = useState(false);

  const { login, isAuthenticated, loading, error, clearErrors } = useAuth();
  const navigate = useNavigate();

  // Redirigir si ya está autenticado
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  // Limpiar errores al montar el componente
  useEffect(() => {
    clearErrors();
  }, [clearErrors]);

  // Versioned logo for cache-busting (deploy a new version on change)
  const logoSrc = '/uni_b_v2.png';

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Nota: mantuvimos showPassword state por si queremos agregar icono para mostrar contraseña.

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    setValidated(true);

    const result = await login(formData.email, formData.password);
    if (result.success) {
      navigate('/dashboard');
    }
  };
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {/* Fondo animado similar al ejemplo */}
      <div className="bg-gradient-anim"></div>
      <div className="ocean" aria-hidden>
        <div className="wave"></div>
        <div className="wave"></div>
      </div>

      <div className="login-box">
        <div className="text-center mb-4">
          <div className="logo-anim mb-3 position-relative d-inline-block logo-circle">
            <div className="logo-circle-inner bg-white rounded-circle d-flex align-items-center justify-content-center overflow-hidden shadow-lg">
              <img src={logoSrc} alt="Logo" className="logo-image" />
            </div>
          </div>
          {/* Only show circular logo (no additional square logo) */}
        </div>

        {error && (
          <Alert variant="danger" className="mb-3">
            <i className="fas fa-exclamation-triangle me-2"></i>
            {error}
          </Alert>
        )}

        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <div className="user-box">
            <Form.Control
              type="text"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <label>Email o Cédula</label>
            <i className="fa-solid fa-user input-icon" />
          </div>

          <div className="user-box">
            <Form.Control
              type={showPassword ? 'text' : 'password'}
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              minLength={6}
            />
            <label>Contraseña</label>
            <i className="fa-solid fa-lock input-icon" />
          </div>

          <div className="d-flex justify-content-between align-items-center mb-3 small text-muted">
            <label className="d-flex align-items-center"><input type="checkbox" className="me-2" />Recordarme</label>
            <a href="/forgot-password" className="fw-bold">¿Olvidaste contraseña?</a>
          </div>

          <Button type="submit" className="btn-submit w-100" disabled={loading}>
            {loading ? (
              <>
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                Verificando...
              </>
            ) : (
              'Ingresar'
            )}
          </Button>
          <div className="text-center mt-3">
            <small>
              ¿Eres socio?{' '}
              <a href="/register-socio" className="fw-bold">Regístrate aquí</a>
            </small>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Login;